window.$ = window.jQuery = require('jquery');

['touchstart', 'touchmove', 'wheel', 'mousewheel'].forEach(function (eventName) {
    window.jQuery.event.special[eventName] = {
        setup: function (data, namespaces, eventHandle) {
            this.addEventListener(eventName, eventHandle, { passive: true });
        },
        teardown: function (namespaces, eventHandle) {
            this.removeEventListener(eventName, eventHandle, false);
        }
    };
});
